import { motion } from "framer-motion";
import Reveal from "../Reveal";

const WORK = [
  { title: "Aura Fintech Platform", client: "Aura Global", category: "Web App & Branding", metric: "+240% Conversion", url: "https://images.unsplash.com/photo-1786455587869-fc2dc0c9f19a?crop=entropy&cs=srgb&fm=jpg&q=85", span: "md:col-span-2 md:row-span-2" },
  { title: "Vortex Automotive", client: "Vortex Mobility", category: "3D Experience & Marketing", metric: "1.2M Monthly Views", url: "https://images.unsplash.com/photo-1782803432396-e168aa0e54a1?crop=entropy&cs=srgb&fm=jpg&q=85", span: "" },
  { title: "Kairo Luxury Living", client: "Kairo Group", category: "Digital Identity & Portal", metric: "Awwwards SOTM", url: "https://images.unsplash.com/photo-1780147343308-7ede77816ee6?crop=entropy&cs=srgb&fm=jpg&q=85", span: "" },
  { title: "Zenith Cloud Architecture", client: "Zenith AI", category: "Product Design & SaaS", metric: "3.5x Engagement", url: "https://images.unsplash.com/photo-1453586857165-eb78d44460ca?crop=entropy&cs=srgb&fm=jpg&q=85", span: "md:col-span-2" },
];

export default function Work() {
  return (
    <section id="work" className="py-28 lg:py-40 bg-panel/40 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-volt mb-4">02 / Selected Work</p>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-4xl lg:text-5xl leading-tight">
              Proof, not promises
            </h2>
          </div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">2019 — Present</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 auto-rows-[280px] gap-4">
          {WORK.map((w, i) => (
            <motion.article
              key={w.title}
              data-testid={`work-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden border border-white/5 ${w.span}`}
            >
              <img
                src={w.url}
                alt={w.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/20 to-transparent" />
              <div className="absolute inset-0 border border-transparent group-hover:border-volt/40 transition-colors duration-500 pointer-events-none" />
              <div className="absolute top-4 right-4 font-mono text-[10px] uppercase tracking-[0.2em] bg-volt text-obsidian font-bold px-3 py-1.5">
                {w.metric}
              </div>
              <div className="absolute bottom-0 inset-x-0 p-6">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-volt">{w.category}</p>
                <h3 className="mt-2 font-display font-bold text-xl sm:text-2xl tracking-tight">{w.title}</h3>
                <p className="mt-1 text-sm text-slate-400">{w.client}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
